module.exports = __webpack_public_path__ + "static/img/product_img3.29f5946.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_img3.png
// module id = bjdh
// module chunks = 0